import React, { Component, Fragment } from 'react';
import CheckboxSelector from './selectors/Checkbox.jsx';

export default class CheckboxModifierContent extends Component {
    constructor(props) {
        super(props);
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
        this.select = this.select.bind(this);
    }

    generateJSXFromData() {
        var result = this.props.modifiers.map( (val, ind, arr) => {
            const mod = this.props.allModifiers[val];
            const choice = this.props.choices[val];
            return <CheckboxSelector select={this.select} key={ind} modifierKey={val} name={mod.name}
                setExtra={this.props.setExtra} setLight={this.props.setLight}
                setNormal={this.props.setNormal} choice={choice} removeModifier={this.props.removeModifier}
                handleModifierQuantityChange={this.props.handleModifierQuantityChange}
                increaseModifierQuantity={this.props.increaseModifierQuantity} decreaseModifierQuantity={this.props.decreaseModifierQuantity}
                showDouble={this.props.showDouble} showHalf={this.props.showHalf} maxQuantity={mod.maxQuantity}/>
        });

        return result;
    }

    select(key) {
        this.props.setWhole(key);
    }

    render() {
        return (
            <div id={`collapse${this.props.bootstrapID}`} className={`collapse ${this.props.shouldShow ? 'show' : ''}`} aria-labelledby={`heading${this.props.bootstrapID}`} data-parent="#availableModifierGroups">
                <div className="card-body card-columns">
                        {this.generateJSXFromData()}
                </div>
            </div>
        );
    }
}